const { gql } = require('graphql-request')

export const OFFICE_CARD_FRAGMENT = gql`
  fragment officeCardInfo on OfficeCard {
    id
    last4
    expDate
    cardType
    isActive
    createdAt
    modifiedAt
    billingInfo {
      firstName
      lastName
      address
      address2
      city
      state
      zip
      email
      phone
    }
  }
` 